import * as React from "react";
import { Checkbox, Divider, Grid, Input, Table } from "semantic-ui-react";

import { CustomQuestionConfig, getQuestionTypeText, QuestionType } from "@teamprevent/common/questionnaires/questionnaireConfig/models";

interface Props {
    customerId: string;
    questionnaireType: string;
    questions: CustomQuestionConfig[];
    onChanged: (questionConfig: CustomQuestionConfig) => void;
}

export const AdditionalQuestionsEdit: React.FunctionComponent<Props> = (props: Props) => {

    const showErrors = true;

    const onTextChanged = (event: React.SyntheticEvent<HTMLElement>, questionText: string, questionId: string) => {
        const question = props.questions.find(q => q.id === questionId);

        props.onChanged({
            ...question,
            questionText
        });
    };

    const onDropdownOptionsChanged = (event: React.SyntheticEvent<HTMLElement>, value: string, questionId: string) => {
        const options = value?.split(",") ?? [];
        const question = props.questions.find(q => q.id === questionId);

        props.onChanged({
            ...question,
            options
        });
    };

    const onIsMandatoryChanged = (event: React.SyntheticEvent<HTMLElement>, isMandatory: boolean, questionId: string) => {
        const question = props.questions.find(q => q.id === questionId);
        props.onChanged({
            ...question,
            isMandatory
        });
    };

    if (props.questions?.length > 0) {
        return (<>
            <Table>
                <Table.Header>
                    <Table.HeaderCell width={5} textAlign="center">Question</Table.HeaderCell>
                    <Table.HeaderCell width={3} textAlign="center">Question Type</Table.HeaderCell>
                    <Table.HeaderCell width={5} textAlign="center">Answer</Table.HeaderCell>
                    <Table.HeaderCell width={3} textAlign="center">Mandatory</Table.HeaderCell>
                </Table.Header>
            </Table>
            <Grid container>
                {props.questions.map(question =>
                    (<Grid.Row key={question.id}>
                        <Grid.Column width={5} textAlign="center">
                            <Input
                                value={question.questionText}
                                showErrors={showErrors}
                                required
                                onChange={(e, d) => onTextChanged(e, d.value, question.id)}
                                fluid
                            />
                        </Grid.Column>
                        <Grid.Column width={3} textAlign="center">{getQuestionTypeText(question)}</Grid.Column>
                        <Grid.Column width={5} textAlign="center">
                            <Input
                                value={question.options?.join(",")}
                                showErrors={showErrors}
                                required
                                onChange={(e, d) => onDropdownOptionsChanged(e, d.value, question.id)}
                                disabled={question.questionType !== QuestionType.DropdownQuestion}
                                fluid
                            />
                        </Grid.Column>
                        <Grid.Column width={3} textAlign="center">
                            <Checkbox
                                checked={question.isMandatory}
                                showErrors={showErrors}
                                required
                                onChange={(e, d) => onIsMandatoryChanged(e, d.checked, question.id)}
                                fluid
                                selection
                            />
                        </Grid.Column>
                    </Grid.Row>)
                )}
            </Grid>
            <Divider />
        </>);
    }

    return null;
};
